import { onError } from '@apollo/client/link/error';
import { Observable } from '@apollo/client/utilities';
import * as Sentry from '@sentry/browser';

function isUnauthorizedError(error: unknown): boolean {
  return (
    typeof error === 'object' &&
    error !== null &&
    (error as Record<string, unknown>).name === 'ServerError' &&
    (error as Record<string, unknown>).statusCode === 401
  );
}

export const createErrorLink = (onUnauthenticatedError: () => Promise<void>) =>
  onError(({ error, forward, operation }) => {
    if (isUnauthorizedError(error)) {
      // If the network error is a 401, we want to handle it by triggering the unauthenticated error handler.
      // This is an "expected" error in the sense that it indicates the user is not authenticated,
      // so we handle it differently than other errors, not capturing it with Sentry
      return new Observable(observer => {
        onUnauthenticatedError()
          .then(() => {
            observer.complete();
          })
          .catch(err => {
            observer.error(err);
          });
      });
    }

    Sentry.captureException(error);

    return forward(operation);
  });
